export {};

NLMK.maskedInput = maskedInput;

$(maskedInput);

function maskedInput() {
    require.ensure(
        ['./module'],
        () => {
            require('./module');
            $('.formTel').mask('+7 (999) 999-99-99');
            $('.formSNILS').mask('999-999-999 99');
            $('.formPassport').mask('9999 999999');
            $('.formCurrencyRu').mask('999 999 999 999 999', {reverse: true});
            $('.formCurrencyEn').mask('999,999,999,999,999', {reverse: true});

            $('.js-mask-Date').mask('00.00.0000');

            $('.js-mask-OnlyDigits').mask('0#');
        },
        'masked-input',
    );
}


// WEBPACK FOOTER //
// ./js/main/module/masked-input/index.js